<template>
<div>
  <nav class="navbar navbar-expand navbar-dark bg-dark">
    <div class="container">
      <a class="navbar-brand" id="nav-principal" href="http://www.apa-pablo-picasso.es">AMPA Pablo Picasso</a>
    </div>
  </nav>

  <div class="row justify-content-center">

    <div class="col-md-4 col-12">
      <div class="card mt-5">
        <h5 class="card-header">Restablecer contraseña</h5>
        <div class="card-body">

          <p>Indica tu NIF/NIE y te enviaremos un enlace por email para que cambies tu contraseña</p>

          <form class="form-horizontal" id="reset-pin" action="" @submit.stop.prevent="restablecerPassword">

          <div class="form-group row">
            <label class="col-4 col-form-label" for="nif">NIF</label>
            <div class="col-8">
              <input id="nif" name="nif" type="text" class="form-control" v-model="nif" :class="validarCampo(validarNIF(nif))">
              <div class="invalid-feedback">Introduce un NIF o NIE válido</div>
            </div>
          </div>

          <p class="text-center"><button type="submit" class="btn btn-primary">Enviar</button></p>

          <div>{{ mensaje_respuesta }}</div>

          </form>

        </div>
      </div>
    </div>

  </div>

</div>

</template>

<script>

import { api } from '../api/api.js';
//import { validarNIF } from '../validacion.js';

export default {
	name: 'RestablecerPassword',
	data() {
		return {
			nif: null,
			validado: false,
			mensaje_respuesta: '',
		}
	},
	watch: {
		nif() {
			this.mensaje_respuesta = '';
		}
	},
	methods: {
		//validarNIF,
		validarNIF() {
			// No validar el NIF por el momento para cubrir el caso del pasaporte
			return true
		},
		validarCampo(condicion) {
			if (! this.validado) {
				return '';
			}
			if (condicion) {
				return 'is-valid';
			} else {
				return 'is-invalid';
			}
		},
		restablecerPassword() {
			if (! this.validarNIF(this.nif)) {
				this.validado = true;
				return;
			}
			this.validado = false;
			this.mensaje_respuesta = '';

			const data = {
				'nif': this.nif,
			}
			api('/acceso/restablecer', 'POST', data)
				.then((data) => {
					if (data.resultado) {
						this.mensaje_respuesta = 'Se ha enviado un email con un enlace para restablecer la contraseña';
					} else {
						this.mensaje_respuesta = data.error;
					}
				}
			);
		},
	}
}
</script>
